import React from "react";

export class ChevronRight extends React.Component {
  render() {
    return (
      <svg
        {...this.props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-chevron-right-icon lucide-chevron-right"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/icons/ChevronRight.js